import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
    loading: false,
    call: {},
    schedules: {},
    error: null,
    twilio_token: {},
    paymentUrl: null,
    history: {},
    scheduleLoader: false,
    connectAccountLoading: false,
};

const CallReducer = (state = initialState, action) => {
    switch (action.type) {
        //call history
        case actionTypes.GET_CALL_HISTORY_INIT:
            return {
                ...state,
                loading: true,
            };

        case actionTypes.GET_CALL_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                history: action.payload,
                error: null,
            };

        case actionTypes.GET_CALL_HISTORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // call details
        case actionTypes.PAYMENT_DETAILS_INIT:
            return {
                ...state,
                loading: true,
            };

        case actionTypes.PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                history: action.payload,
                loading: false,
                error: null,
            };
        case actionTypes.PAYMENT_DETAILS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default CallReducer;
